import React, {useEffect, useState} from 'react'
import {AppraiserProfileFile} from "../../../api/ApiTypes.ts";
import {useFileApi} from "../../../context/ApiContext.tsx";
import SamButton from "../../../components/SamButton.tsx";
import Modal from "../../../components/Modal.tsx";
import {UploadIcon} from "lucide-react";
import {MultiFileUploadContentFromAppraiser} from "../../../components/MultiFileUploadFromAppraiser.tsx";
import {AppraiserProfileTabProps} from "./AppraiserProfile.tsx";
import {LoadingSkeleton} from "./DocumentsSkeleton.tsx";
import {DocumentsTable} from "./DocumentsTable.tsx";

export const Documents: React.FC<AppraiserProfileTabProps> = ({appraiserInfo}) => {
    const [files, setFiles] = useState<AppraiserProfileFile[]>([])
    const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState<boolean>(false);
    const [refreshDocuments, setRefreshDocuments] = useState(false);
    const [ isLoadingFiles, setIsLoadingFiles ] = useState<boolean>(false);

    const fileApi = useFileApi();

    const getAppraiserDocuments = async () => {
        if (!appraiserInfo?.id) {
            return;
        }

        setIsLoadingFiles(true)
        await fileApi.getAppraiserDocumentFiles(appraiserInfo.id)
            .then(setFiles)
            .catch(console.log)
            .finally(() => {
                setIsLoadingFiles(false);
            })
    };

    useEffect(() => {
        getAppraiserDocuments();
    }, [appraiserInfo?.id, refreshDocuments]);

    const closeUploadFileModal = () => {
        setIsAddDocumentModalOpen(false);
    }

    const handleUploadSuccess = () => {
        closeUploadFileModal();
        setRefreshDocuments(prev => !prev);
    };

    return (
        <div>
            <SamButton
                type="button"
                onClick={() => setIsAddDocumentModalOpen(true)}
                style={{marginBottom: '1rem'}}
                disabled={(isAddDocumentModalOpen || isLoadingFiles)}
            >
                <span className="inline-flex items-center space-x-1">
                    <UploadIcon className="h-4 w-4" />
                    <span>Add Documents</span>
                </span>
            </SamButton>

            {isLoadingFiles ? (
                <LoadingSkeleton />
            ) : files.length === 0 ? (
                <div>No files available</div>
            ) : (
                <DocumentsTable files={files} />
            )}

            <Modal
                title={'Upload Documents'}
                isOpen={isAddDocumentModalOpen}
                onClose={closeUploadFileModal}
            >
                <MultiFileUploadContentFromAppraiser
                    forAppraiser={appraiserInfo?.id}
                    onSuccess={handleUploadSuccess}
                    onCancel={closeUploadFileModal}
                    forOrder={null}
                    requiresEnv={false}
                />
            </Modal>
        </div>
    );
};